function mapPublicExhibitions(items) {
  if (!Array.isArray(items)) return []
  return items
    .filter(item => item && item.id != null)
    .map(item => ({
      id: item.id,
      name: item.name || '',
      location: item.address || '',
      startTime: item.startTime || '',
      endTime: item.endTime || '',
      coverUrl: item.coverUrl || '',
      linkUrl: item.linkUrl || '',
      status: item.status || ''
    }))
}

function compareTime(left, right, field, direction) {
  const leftValue = String(left && left[field] || '')
  const rightValue = String(right && right[field] || '')
  return direction * leftValue.localeCompare(rightValue)
}

function buildExhibitionSchedule(items) {
  const source = Array.isArray(items) ? items : []
  const ended = source
    .filter(item => item && item.status === 'ENDED')
    .sort((left, right) => compareTime(left, right, 'endTime', 1))
  const ongoing = source
    .filter(item => item && item.status === 'ONGOING')
    .sort((left, right) => compareTime(left, right, 'startTime', 1))
  const upcoming = source
    .filter(item => item && item.status === 'UPCOMING')
    .sort((left, right) => compareTime(left, right, 'startTime', 1))

  const primary = ongoing.shift() || upcoming.shift() || null
  const result = primary ? [...ended, primary, ...ongoing, ...upcoming] : [...ended, ...upcoming]
  return {
    items: result,
    initialSlide: primary ? ended.length : Math.max(ended.length - 1, 0)
  }
}

function getExhibitionTargetUrl(item = {}) {
  return item.linkUrl || ''
}

function isCompletedExhibition(item) {
  return Boolean(item && item.status === 'ENDED')
}

function parseDate(value) {
  if (!value) return null
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00Z`)
  return Number.isNaN(date.getTime()) ? null : date
}

function formatExhibitionDate(item = {}, siteType = 'EN') {
  const start = parseDate(item.startTime)
  const end = parseDate(item.endTime)
  if (!start) return ''

  if (String(siteType).toUpperCase() === 'ZH') {
    const startMonth = start.getUTCMonth() + 1
    const startDay = start.getUTCDate()
    const startYear = start.getUTCFullYear()
    if (!end) return `${startYear}年${startMonth}月${startDay}日`

    const endMonth = end.getUTCMonth() + 1
    const endDay = end.getUTCDate()
    const endYear = end.getUTCFullYear()
    if (startYear === endYear && startMonth === endMonth) {
      return `${startYear}年${startMonth}月${startDay}日–${endDay}日`
    }
    if (startYear === endYear) {
      return `${startYear}年${startMonth}月${startDay}日–${endMonth}月${endDay}日`
    }
    return `${startYear}年${startMonth}月${startDay}日–${endYear}年${endMonth}月${endDay}日`
  }

  const month = new Intl.DateTimeFormat('en-US', { month: 'long', timeZone: 'UTC' })
  const startMonth = month.format(start)
  const startDay = start.getUTCDate()
  const startYear = start.getUTCFullYear()
  if (!end) return `${startMonth} ${startDay}, ${startYear}`

  const endMonth = month.format(end)
  const endDay = end.getUTCDate()
  const endYear = end.getUTCFullYear()
  if (startYear === endYear && startMonth === endMonth) {
    return `${startMonth} ${startDay}–${endDay}, ${startYear}`
  }
  if (startYear === endYear) {
    return `${startMonth} ${startDay}–${endMonth} ${endDay}, ${startYear}`
  }
  return `${startMonth} ${startDay}, ${startYear}–${endMonth} ${endDay}, ${endYear}`
}

module.exports = {
  formatExhibitionDate,
  isCompletedExhibition,
  mapPublicExhibitions,
  buildExhibitionSchedule,
  getExhibitionTargetUrl
}
